<!-- Hero Section -->
<div class="container">
<div class="d-lg-flex position-relative">
  <div style="min-height: 700px" class="container d-lg-flex align-items-lg-center space-top-2 space-top-md-5 space-lg-0 ">
    <!-- Content -->
    <div class="row w-100">
      <div class="col-lg-5">
        <h1 class="display-4 font-size-md-down-5 font-weight-medium mb-3">Conference Planning Services</h1>        <p>
<!--          Planning a conference can be a daunting task. From finding the right venue to coordinating with vendors, there are many moving parts to consider.-->
          <br>
          Let us take over the planning and execution of your next conference. We will handle everything from start to finish, so you can focus on what you do best.
        </p>

        <div class="d-flex align-items-center flex-wrap">
          <button class="btn btn-soft-primary btn-wide transition-3d-hover" type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Get Started</button>

          <!-- Fancybox -->

          <!-- End Fancybox -->
        </div>
      </div>
    </div>
    <!-- End Content -->

    <!-- SVG Background -->
    <div id="SVGMainHero" class="col-lg-9 col-xl-7  d-none d-lg-block position-absolute top-0 right-0 pr-0" style="margin-top: 50px;">
      <figure class="ie-main-hero text-right">
        <img class="img-fluid" src="../../assets/website/planning-hero.png" alt="Image Description">
      </figure>
    </div>
    <!-- End SVG Background -->
  </div>
</div>
</div>
<!-- End Hero Section -->


<div class="container space-1">
  <div class="row justify-content-lg-between">


    <div class="col-lg-12">
      <div class="row">
        <div class="col-sm-3 mt-4 text-center">
          <!-- Icon Blocks -->
          <figure id="icon33" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
            <i class="fad fa-utensils-alt home-icon-theme"></i>
          </figure>
          <h4 class="h5">Food & Beverage</h4>
          <p class="font-size-1">From managing menus, to food quantities to coffee consumption. Let our team work with the hotel to get your menus built exactly how attendees want</p>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-sm-3 mt-4 text-center">
          <!-- Icon Blocks -->
          <figure id="icon218" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
            <i class="fad fa-hotel home-icon-theme"></i>
          </figure>
          <h4 class="h5">Room Blocks</h4>
          <p class="font-size-1">We will manage staff rooms, vip rooms, reservations and attrition to simplify accomidations for your next event! </p>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-sm-3 mt-4 text-center">
          <!-- Icon Blocks -->
          <figure id="icon29" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
            <i class="fad fa-map-marked-alt home-icon-theme"></i>
          </figure>
          <h4 class="h5">Floor plans and session schedule</h4>
          <p class="font-size-1">Take the guesswork out of session sizes, locations and scheduling throughout the conference.</p>
          <!-- End Icon Blocks -->
        </div>



        <div class="col-sm-3 mt-4 text-center">
          <!-- Icon Blocks -->
          <figure id="icon230" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
            <i class="fad fa-megaphone home-icon-theme"></i>
          </figure>
          <h4 class="h5">Marketing & Promotion</h4>
          <p class="font-size-1">We know how to market events. Make your event stand out with our advanced marketing services! Social media, email campaigns and more!</p>
          <!-- End Icon Blocks -->
        </div>
        <div class="col-sm-3 mt-4 text-center">
          <!-- Icon Blocks -->
          <figure id="icona28" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
            <i class="fad fa-money-check-edit-alt home-icon-theme"></i>
          </figure>
          <h4 class="h5">Sponsorships</h4>
          <p class="font-size-1">Relationships with sponsors and order fulfillment are arguably the most important part of a conferences financial health. We can help you manage those relationships.</p>
          <!-- End Icon Blocks -->
        </div>
        <div class="col-sm-3 mt-4 text-center">
          <!-- Icon Blocks -->
          <figure id="icon280" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
            <i class="fad fa-megaphone home-icon-theme"></i>
          </figure>
          <h4 class="h5">Print Materials</h4>
          <p class="font-size-1">Signage, Badges, Lanyards, swag, banners, backdrops we can do it all. Let our team coordinate so you dont have to!</p>
          <!-- End Icon Blocks -->
        </div>
        <div class="col-sm-3 mt-4 text-center">
          <!-- Icon Blocks -->
          <figure id="icon32" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
            <i class="fad fa-couch home-icon-theme"></i>
          </figure>
          <h4 class="h5">Show Decorations</h4>
          <p class="font-size-1">Stage decorations, registration desks, furniture and the overall brand of your conference. Our design team has you covered!</p>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-sm-3 mt-4 text-center">
          <!-- Icon Blocks -->
          <figure id="icon34" class="mx-auto ie-height-56 w-100 max-width-8 mb-3">
            <i class="fad fa-id-card-alt home-icon-theme"></i>
          </figure>
          <h4 class="h5">Vendor Liaison</h4>
          <p class="font-size-1">Working with multiple vendors can be a headache for conference planners, let our team handle everything. AV, union labor, hotel, WIFI and more!</p>
          <!-- End Icon Blocks -->
        </div>
        </div>

    </div>
  </div>
</div>

<!-- Hero Section -->
<div id="SVGheroSectionBg" class=" position-relative gradient-half-primary-v3">
  <div class="container space-2">
    <div class="row align-items-lg-center">
      <div class="col-lg-5 mb-7 mb-lg-0">
        <!-- Info -->
        <h1 class="mb-4">We create the best <span class="text-primary font-weight-semi-bold">solution</span> for you.</h1>
        <p>Partner with OkWhen and experience the difference that true full-service management delivers. Our seasoned team seamlessly handles every aspect of your event, allowing you to focus on what matters most—connecting with your audience and achieving your goals.</p>
        <!-- End Info -->
      </div>

      <div class="col-lg-7">
        <!-- SVG Icon -->
        <figure class="ie-working-men">
          <img class="js-svg-injector" src="../../assets/svg/illustrations/working-men.svg" alt="Image Description"
               data-parent="#SVGheroSectionBg">
        </figure>
        <!-- End SVG Icon -->
      </div>
    </div>
  </div>

  <!-- SVG Background -->
  <figure class="position-absolute right-0 bottom-0 left-0">
    <img class="js-svg-injector" src="../../assets/svg/components/wave-1-bottom-sm.svg" alt="Image Description"
         data-parent="#SVGheroSectionBg">
  </figure>
  <!-- End SVG Background Section -->
</div>
<!-- End Hero Section -->
